/**
 * Copyright (c) 2026 Spicy Friends Ltd.
 * All rights reserved.
 *
 * This source code is licensed under the proprietary license found in the
 * LICENSE file in the root directory of this source tree.
 */

const PROFILE_LAYOUT_ROUTE_ID = '/(auth)/(main-layout)/profile/$profileId'

export type ProfileLayoutHeadData = {
  profileName: string | null | undefined
}

/**
 * Reads the profile name loaded by the `profile/$profileId` layout loader, for child route `head` functions.
 * Kept out of the layout route file so child routes do not import it and defeat code splitting.
 */
export function profileNameFromLayoutMatches(
  matches: ReadonlyArray<{ routeId: string; loaderData?: unknown }>
): string | null | undefined {
  const layoutMatch = matches.find((match) => match.routeId === PROFILE_LAYOUT_ROUTE_ID)
  return (layoutMatch?.loaderData as ProfileLayoutHeadData | undefined)?.profileName
}
